import React from 'react';
import { setGetHistoryList } from '../../store/thunk/setGetHistoryList';
import {useDispatch, useSelector} from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import {getRows, columns} from './heplers';
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';
import {useFormik, FormikContext} from "formik";

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        height: 'calc(100% - 40px)', 
        overflowY: 'scroll', 
        paddingTop: 0
    },
    wrap: {
        padding: 0, 
               background: '#1b2039', 
               borderRadius: 8, 
               marginBottom: 12
   },
   search: {
       padding: 10,
       background: '#141b33',
       paddingLeft: 10,
       border: '1px solid #141b33',
       color: '#fff',
       outline: 'none',
       margin: 10,
       width: '97.3%'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}))

const EventList = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [desc, setDesc] = React.useState(false);
    const [order, setOrder] = React.useState('date_event');
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetHistoryList({
            page: 1,
            rowsPerPage: 10,
            order: 'date_event',
            desc: true,
            search: '',
            date_from: 0,
            date_to: new Date().getTime()
        }));
    }, []);

    const event_history = useSelector(state => state.report_event.list);
    const rows = React.useMemo(() => getRows(event_history.data), [event_history])

    
    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});

    return (
        <div className={classes.root}>
            <Title label="Отчет по событиям" />
            <div className={classes.wrap} style={{display: 'flex', alignItems: 'center'}}>
            <FormikContext.Provider value={formik}>
                <form>
                    <div style={{
                        background: '#1b2039', 
                        borderRadius: 8,
                        paddingLeft: 20
                    }}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }

                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetHistoryList({
                                        page: 1,
                                        rowsPerPage: 10,
                                        order: v.id,
                                        desc: !desc,
                                        search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }

                                    formik.setFieldValue('date_to', date.getTime());

                                    dispatch(setGetHistoryList({
                                        page: 1,
                                        rowsPerPage: 10,
                                        order: v.id,
                                        desc: !desc,
                                        search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                    }))
                                    
                                }}
                            />
                        </div>
                    </div>
                </form>
            </FormikContext.Provider>
                <input 
                    type="text"
                    placeholder="Поиск"
                    className={classes.search}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGetHistoryList({
                            page: 1,
                            rowsPerPage: 10,
                            order,
                            desc,
                            search: v.target.value,
                            date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                        }));
                        setSearch(v.target.value);
                    }}
                />
            </div>
            <div className={classes.wrapTable}>
                <TableCasino 
                    order={(v) => {
                        dispatch(setGetHistoryList({
                            page: 1,
                            rowsPerPage: 10,
                            order: v.id,
                            desc: !desc,
                            search,
                            date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                        }));
                        setOrder(v.id);
                        setDesc(!desc);
                    }}
                    pagination
                    allPage={event_history.countPage}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetHistoryList({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc,
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetHistoryList({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc,
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                />
            </div>
            
        </div>  
    )
}

export default EventList;